export class VideoDiagnosticsService {

    static $inject = ["$http"];

    constructor(
        private readonly $http: angular.IHttpService
    ) { }

    getAlarms(vehicleId, startTime: moment.Moment, endTime: moment.Moment, invalidateCache: boolean = false): angular.IPromise<any> {
        return this.$http({
            url: `/api/ceibaApi/alarms/${vehicleId}`,
            method: "GET",
            params: {
                startTime: startTime.toISOString(),
                endTime: endTime.toISOString(),
                minsToLive: 30,
                invalidateCache: invalidateCache
            }
        }).then((response) => {
            return response.data;
        });
    }



}
